export enum TherapistDashboardTabsEnum {
  HOME = 1,
  MY_SESSIONS = 2,
  MY_MESSAGES = 3,
  SUBSCRIPTIONS = 4,
  MY_CLIENTS = 5,
  TUTORIAL = 6
}
